/* eslint-disable import/prefer-default-export */
import GlobalToastType from '../types/GlobalToastType';

const GlobalToastReducer = (state = [], action) => {
  const { payload, type } = action;
  switch (type) {
    case GlobalToastType.actions.addToast:
      if (state.find((x) => x.text === payload.text)) {
        return [...state];
      }
      return [payload, ...state];

    case GlobalToastType.actions.removeToast:
      return state.filter((toast) => toast.id !== payload);

    default:
      return state;
  }
};

export { GlobalToastReducer };
